import StatsDisplay from '../../../../components/StatsDisplay';
import { asyncRequestStates } from '../../../../hooks/useAsyncRequest';
import useStats from '../../../stats/hooks/useStats';

const StatsWheels = () => {
  const {
    stats: { averages },
    statsState,
  } = useStats('all', 'global');

  return (
    statsState === asyncRequestStates.SUCCESS && (
      <StatsDisplay data={averages} type="wheels" />
    )
  );
};

export default StatsWheels;
